import React, { useState } from 'react';

import RequestService from "../../services/request.service";

import AuthService from '../../features/auth/auth.service'

import { Form, Button, Modal } from 'react-bootstrap';

import { toast } from 'react-toastify'

import Dialog from '../../services/Dialogs'

import { Formik } from 'formik';
import * as yup from 'yup';


const ModalAsesorAsignarGerente = ( params : any ) => {

  const user = AuthService.getCurrentUser()

  const { show, handleClose, empleado } = params



  const dialog = new Dialog();



  const [ sucursales, setSucursales] = useState<any>([{ gerentes : [] }])

  const cargarGerentes = async() => {

    try{
      let res = await RequestService.getEndPoint('registro/lista_gerentes')
      // console.log(res.data)
      setSucursales(res.data)
    }
    catch(e){
      toast.error('Tuvimos problemas al cargar la lista de Gerentes')
    }

  }


  React.useEffect(() => {
    cargarGerentes()
  }, []);


  const mensajes_validacion_generico = "Este campo es obligatorio"
  const schema = yup.object().shape({
      idgerente : yup.string().nullable().required(mensajes_validacion_generico),
  });



const [ envio_server, setSeEnvio ] = useState<boolean>(false)


const enviarFormulario = async (registro:any,event:any) =>{
      await dialog.open({
        accept: 'Si',
        cancel: 'Espera',
        dialogClass: '',
        message: '¿Estás seguro de la información?',
        target: event.target,
        template: ''
      })
      let dialogo : any = await dialog.waitForUser()
      if(dialogo){
        try{

        setSeEnvio(true)
        let res_ = await RequestService.update( `recursos_humanos/asigna_gerente_asesor/${empleado.uuid}` , { ...registro })

        if(res_){
          toast.success('El Registro se Actualizó correctamente')
          setTimeout(()=>{
            handleClose()
          },0)
        }
        else{
          toast.error('Problemas...')
        } 
        }
        catch(e:any){
          toast.error(e.response.data)
          // console.log(e.response.data)
        } 
        
      }
     
}

const dameAlGerenteDeEsteUUID = (uuid_gerente:string)=>{
  let nombre_gerente = ""
  for (var i = 0; i < sucursales.length; ++i) {
    for (var j = 0; j < sucursales[i].gerentes.length; ++j) {
      // code...
      if(sucursales[i].gerentes[j].uuid === uuid_gerente) nombre_gerente = sucursales[i].gerentes[j].nombres + ' ' + sucursales[i].gerentes[j].paterno + ' ' + sucursales[i].gerentes[j].materno 
    }
  }
  return nombre_gerente
}



  return (
    <>
    <Formik
      validationSchema={schema}
      onSubmit={(values,e)=>{enviarFormulario(values, e)}}
      initialValues={{
            idgerente : empleado.idgerente ? empleado.idgerente.uuid : "" ,
      }}
    >
      {({
        handleSubmit,
        handleChange,
        setFieldValue,
        handleBlur,
        values,
        touched,
        isValid,
        errors,
      }) => (

            <Modal show={show}   onHide={handleClose} backdrop="static">
              <Modal.Header closeButton>
                <Modal.Title>Asignar Gerente</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {
                  // JSON.stringify(empleado.idgerente)
                }

                    <small>Asesor</small>
                    <p>{empleado.nombres} {empleado.paterno} {empleado.materno} </p>

                    <small>Gerente Actual</small>
                    { empleado.idgerente && ( <p>{empleado.idgerente.nombres} {empleado.idgerente.paterno} {empleado.idgerente.materno} </p> ) }
                    { !empleado.idgerente && ( <p>Actualmente no tiene un Gerente Asignado</p> ) }

                    <small>Sucursal</small>
                    <p>{empleado.idsucursal.nombre_sucursal}</p>



              <Form id='my-form' noValidate onSubmit={handleSubmit}>


                      <Form.Group className="mb-3" controlId="idgerente">
                        <Form.Label>Selecciona al gerente</Form.Label>
                        <Form.Select required name="idgerente" value={values.idgerente} onChange={(e)=>{ setFieldValue('idgerente', e.target.value ) }} isInvalid={!!errors.idgerente}>
                          <option value="">SELECCIONA UN GERENTE</option>
                          {
                            sucursales.map( sucursal =>
                              <React.Fragment key={ Math.random().toString(36).substr(2, 9) }>
                                <optgroup  label={sucursal.nombre_sucursal}>
                                  {
                                    sucursal.gerentes.map( gerente =>
                                      <React.Fragment key={ Math.random().toString(36).substr(2, 9) }>
                                        <option value={gerente.uuid}> {gerente.nombres} {gerente.paterno} {gerente.materno}</option>
                                      </React.Fragment>
                                    )
                                  }
                                </optgroup>
                              </React.Fragment>
                            )
                          }

                        </Form.Select>
                        <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                        <Form.Control.Feedback type="invalid"> {errors.idgerente} </Form.Control.Feedback>
                      </Form.Group>



              </Form>



              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" disabled={envio_server} onClick={handleClose}>
                  Cancelar
                </Button>
                <Button variant="success" disabled={envio_server} form='my-form' type="submit">Guardar <i className="fa fa-save"/></Button>
              </Modal.Footer>
            </Modal>


      )}
    </Formik>



    </>
  );
}


export default ModalAsesorAsignarGerente;